export default {
  allMemberships: [],
  singleMembershipPlan: {},
};
